// Simple pluralize function
export default function pluralize(word: string, count: number, includeNumber?: boolean): string {
  if (count === 1) {
    return includeNumber ? `1 ${word}` : word;
  }

  // Simple pluralization rules
  let plural = word;
  if (word.endsWith("y")) {
    plural = word.slice(0, -1) + "ies";
  } else if (
    word.endsWith("s") ||
    word.endsWith("x") ||
    word.endsWith("ch") ||
    word.endsWith("sh")
  ) {
    plural = word + "es";
  } else {
    plural = word + "s";
  }

  return includeNumber ? `${count} ${plural}` : plural;
}
